import type { TransCode } from '@/lib/transactions-api';

/**
 * ILOŚĆ ZE ZNAKIEM WPŁYWU NA STAN — do POKAZANIA, nie do zapisania.
 *
 * ⚠️ ZGŁOSZONE 2026-08-10: „ilość zarówno w pobraniach jak i uzupełnieniach jest jako PLUS (+).
 * Wydania powinny raczej pokazywać stan na minus". W SPS `TransactionLog.QTY` jest dla wydania
 * (`WN`) i uzupełnienia (`REN`) tak samo DODATNIE — kierunek niesie `TRANSCODE`, nie liczba.
 * Wiersz wydania i wiersz uzupełnienia wyglądały więc na ekranie identycznie, a to są operacje
 * przeciwne.
 *
 * ⚠️ ZNAK LICZYMY, A NIE BIERZEMY WARTOŚCI BEZWZGLĘDNEJ. `-qty` dla `WN` odwraca też przypadek
 * odwrotny (gdyby w bazie klienta stanęło wydanie ujemne, czyli zwrot, wyjdzie plus), a
 * `-Math.abs(qty)` zamieniłby taki zwrot w kolejne wydanie i skłamał o kierunku.
 *
 * ⚠️ `IA` ZOSTAJE TAK, JAK STOI W BAZIE. Korekta inwentaryzacyjna niesie własny znak — użytkownik
 * potwierdził to na wierszach `74605`/`74606` („te prawidłowo mają stan na minus"). Doklejenie jej
 * naszego znaku odwróciłoby korekty dodatnie.
 *
 * ⚠️ `DD` TAK SAMO — kod występuje we wszystkich sprawdzonych bazach klientów, ale jego znaczenia
 * NIE POTWIERDZILIŚMY. Nadanie mu kierunku byłoby zgadywaniem pokazanym jako fakt.
 */
export function iloscZeZnakiem(transCode: TransCode, qty: number): number {
  const z = transCode === 'WN' ? -qty : qty;
  /** ⚠️ `-0` wychodzi z negacji zera i przecieka do eksportu jako osobna wartość. Prostujemy. */
  return z === 0 ? 0 : z;
}

/** Ta sama liczba do pokazania: plus wypisujemy jawnie, żeby kierunek był widoczny bez czytania kodu. */
export function iloscNaEkran(transCode: TransCode, qty: number): string {
  const z = iloscZeZnakiem(transCode, qty);
  return z > 0 ? `+${z}` : String(z);
}
